import builder from '../builder';
import Cog from '../../streamline-icons/light/cog.svg';

export default builder('IconCogLight', Cog);
